module.exports = __webpack_public_path__ + "static/media/icon_phoneLight.f4220571.svg";